import { render, staticRenderFns } from "./zero-level2-form.vue?vue&type=template&id=39861e62&"
import script from "./zero-level2-form.vue?vue&type=script&lang=js&"
export * from "./zero-level2-form.vue?vue&type=script&lang=js&"
import style0 from "./zero-level2-form.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports